<script>
    import HomeOffer from '../../components/offer/HomeOffer.svelte';
    import HeaderMin from '../../components/HeaderMin.svelte';
    import OfferLayout from '../../components/offer/OfferLayout.svelte';
    import LegalsComponent from '../../components/comparator/components/LegalsComponent.svelte';

    import { store } from '../../Store.svelte';
    import { navigate } from 'svelte-routing';

    let isOffnet = $store.requestedAddress.offnetCoverage;
    let rightClickTextHeader = isOffnet ? '' : 'Comparador negocios';
</script>

<HeaderMin
    rightClickText={rightClickTextHeader}
    rightClick={() => navigate('/comparador/negocios', { replace: false })}
/>
<OfferLayout let:toggleEditAddress>
    <HomeOffer {toggleEditAddress}></HomeOffer>
</OfferLayout>
<LegalsComponent />
